import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  IconButton,
  Card,
  CardMedia,
  CardContent,
  Button,
} from "@mui/material";
import { Link } from "react-router-dom";
import StarIcon from "@mui/icons-material/Star";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useSelector } from "react-redux";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import category1 from "../../assets/images/Home_page_image/categories1.png";
import category2 from "../../assets/images/Home_page_image/categories2.png";
import category3 from "../../assets/images/Home_page_image/categories3.png";
import category4 from "../../assets/images/Home_page_image/categories.4.png";
import category5 from "../../assets/images/Home_page_image/categories1.png";
import category6 from "../../assets/images/Home_page_image/categories2.png";
import category7 from "../../assets/images/Home_page_image/categories3.png";
import category8 from "../../assets/images/Home_page_image/categories.4.png";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { urls } from "../../urls/urls";
import { useFetch } from "../../hooks";

export const CategoriesCarousel = () => {
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = React.useState(0);
  const visibleCards = 5;
  const [categories, setCategories] = useState([]);
  const apptoken = useSelector((state) => state.user.apptoken);

  const latitude = useSelector(
    (state) => state.user.userLocation?.latitude ?? null,
  );
  const longitude = useSelector(
    (state) => state.user.userLocation?.longitude ?? null,
  );
  const [vendors, setVendors] = useState([]);
  useEffect(() => {
    if (apptoken) {
      fetchData();
    }
  }, [apptoken]);

  const {
    data: categoryData,
    isLoading: isCategoriedLoading,
    error,
    fetchData,
  } = useFetch(BASE_URL_TEST + urls("getAllCategories"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apptoken ? `Bearer ${apptoken}` : "",
    },
  });

  useEffect(() => {
    if (categoryData && categoryData["status"] === true) {
      console.log("categoryData", categoryData);
     const dynamicCategories = categoryData.data
      .filter((item) => item.status === 1) 
      .map((item) => ({
        name: item.name,
        description: item.description,
        image: item.image_url,
        categoryId: item.category_id,
      }));
      setCategories(dynamicCategories);
    }
  }, [categoryData]);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? categories.length - visibleCards : prevIndex - 1,
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex >= categories.length - visibleCards ? 0 : prevIndex + 1,
    );
  };

  const handleImageClick = async (categoryid) => {
    console.log("categoryid", categoryid);

    const radius = 20;
    const vtype = "regular";
    try {
      const response = await fetch(
        `${BASE_URL_TEST}/api/main/vendors?lat=${latitude}&lng=${longitude}&radius=${radius}&vtype=${vtype}&categoryids=${categoryid}`,
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      if (data?.vendors) {
        const formattedVendors = data.vendors.map((item) => ({
          id: item.id,
          name: item.name,
          shopName: item.shop_name,
          description:
            Array.isArray(item.categories) && item.categories.length > 0
              ? item.categories.map((c) => c.description).join(", ")
              : Array.isArray(item.listCategories) &&
                  item.listCategories.length > 0
                ? item.listCategories.map((c) => c.description).join(", ")
                : "",
          image: item.store_image,
          distance: item.distance
            ? `${item.distance} kms near to your Location`
            : "N/A",
          rating: "4.8" || "N/A",
          address: `${item.street}, ${item.city}, ${item.state}, ${item.country}, ${item.pincode}`,
          openTime: item.open_time,
          closeTime: item.close_time,
          latitude: item.latitude,
          longitude: item.longitude,
          phoneNumber: item.phone_number,
          regularListType: item.reg_list_type,
        }));

        // navigate(`/category/${categoryid}`, {
        //   state: { vendors: formattedVendors, categoryid: categoryid },
        // });

        const categoryName = categories
          .find((item) => item.categoryId === categoryid)
          ?.name.replace(/\s+/g, "-")
          .toLowerCase();

        navigate(`/category/${categoryName}`, {
          state: {
            vendors: formattedVendors,
            categoryid: categoryid,
          },
        });

        console.log("Formatted Vendors data:", formattedVendors);
      } else {
        console.error("No vendors found in the response data");
      }
    } catch (error) {
      console.error("API call failed:", error);
    }
  };

  return (
    <>
      {/* Categories Section */}
      <Box sx={{ textAlign: "left", width: "100%", marginBottom: "50px" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "16px",
            marginX: { xs: 2, sm: 5, md: 4 },
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              marginBottom: "16px",
              color: "#333",
              marginLeft: { xs: 0, md: 15, lg: 1 },
              fontSize: {
                xs: "1rem",
                sm: "1.5rem",
                md: "1.75rem",
                lg: "1.75rem", // Fix typo from "1,75rem"
              },
            }}
          >
            Categories
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Typography
              variant="body1"
              component={Link}
              to="/see-allcategorys"
              sx={{
                textDecoration: "none",
                color: "#f57c00",
                fontWeight: "bold",
                cursor: "pointer",
                fontSize: "16px",
              }}
            >
              See All
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            backgroundColor: "#F79942",
            borderRadius: "8px",
            position: "relative",
            display: "flex",
            alignItems: "center",
            overflow: "hidden",
            width: "95%",
            maxWidth: "100vw",
            margin: "0 auto",
            paddingX: { xs: 2, sm: 6 },
            paddingY: { xs: 2, sm: 4 },
          }}
        >
          <IconButton
            onClick={handlePrev}
            sx={{
              position: "absolute",
              left: "8px",
              zIndex: 2,
              backgroundColor: "rgba(0,0,0,0.5)",
              color: "#fff",
              borderRadius: "50%",
              fontSize: "30px",
              cursor: "pointer",
              "&:hover": {
                backgroundColor: "rgba(0,0,0,0.7)",
              },
            }}
          >
            <ArrowBackIosIcon />
          </IconButton>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              width: "100%",
              transition: "transform 0.5s ease-in-out",
              transform: `translateX(-${currentIndex * (100 / visibleCards)}%)`,
            }}
          >
            {categories.map((category) => (
              <Box
                key={category.name}
                sx={{
                  flex: `0 0 ${100 / visibleCards}%`,
                  textAlign: "center",
                  transition: "opacity 0.3s ease-in-out",
                }}
              >
                <Box
                  component="img"
                  src={category.image}
                  alt={category.name}
                  onClick={() => handleImageClick(category.categoryId)}
                  sx={{
                    width: { xs: "120px", sm: "160px", md: "250px" },
                    height: { xs: "100px", sm: "140px", md: "180px" },
                    marginBottom: "8px",
                    borderRadius: "8px",
                    cursor: "pointer",
                    transition:
                      "transform 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 0.4s cubic-bezier(0.25, 0.8, 0.25, 1)",
                    "&:hover": {
                      transform: "scale(1.08)",
                    },
                  }}
                />
                <Typography
                  sx={{
                    fontSize: { xs: "14px", sm: "16px", md: "16px" },
                    fontWeight: "bold",
                    color: "#fff",
                  }}
                >
                  {category.name}
                </Typography>
              </Box>
            ))}
          </Box>

          <IconButton
            onClick={handleNext}
            sx={{
              position: "absolute",
              right: "8px",
              zIndex: 2,
              backgroundColor: "rgba(0,0,0,0.5)",
              color: "#fff",
              borderRadius: "50%",
              fontSize: "30px",
              cursor: "pointer",
              "&:hover": {
                backgroundColor: "rgba(0,0,0,0.7)",
              },
            }}
          >
            <ArrowForwardIosIcon />
          </IconButton>
        </Box>
      </Box>
    </>
  );
};
